var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonegrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9603 11.6663C9.704 11.6663 8.44183 11.3742 7.17383 10.79C5.90594 10.2058 4.73994 9.38167 3.67583 8.31767C2.61605 7.25356 1.79405 6.08856 1.20983 4.82267C0.625607 3.5569 0.333496 2.29584 0.333496 1.03951C0.333496 0.839508 0.400163 0.67173 0.533496 0.536175C0.666829 0.40073 0.833496 0.333008 1.0335 0.333008H3.20783C3.37616 0.333008 3.52466 0.387952 3.65333 0.497841C3.782 0.607619 3.86383 0.743286 3.89883 0.904841L4.281 2.86634C4.30744 3.04834 4.30188 3.20473 4.26433 3.33551C4.22666 3.46629 4.15911 3.57612 4.06166 3.66501L2.522 5.16384C2.76977 5.61762 3.05288 6.0469 3.37133 6.45167C3.68966 6.85634 4.03433 7.24284 4.40533 7.61117C4.77111 7.97706 5.16 8.31684 5.572 8.63051C5.984 8.94417 6.42888 9.23606 6.90666 9.50617L8.40266 7.99717C8.507 7.88862 8.63333 7.81251 8.78166 7.76884C8.92988 7.72529 9.08394 7.71462 9.24383 7.73684L11.095 8.11384C11.2633 8.15829 11.4007 8.24417 11.5072 8.37151C11.6136 8.49884 11.6668 8.64328 11.6668 8.80484V10.9663C11.6668 11.1663 11.5991 11.333 11.4637 11.4663C11.3281 11.5997 11.1603 11.6663 10.9603 11.6663Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonegrey);
export default __webpack_public_path__ + "static/media/phone grey.689f433db5104b2d9554fbb2c97d8c47.svg";
export { ForwardRef as ReactComponent };